import { Controller } from "@hotwired/stimulus";

// Live-previews MonsterAttack#damage_description as the author types, so they see exactly what
// the sheet will show. Mirrors the model: the dice half is regenerated (damage + signed bonus,
// or "Arma" for a weapon attack, or nothing at all), then the effect is appended with a space
// unless it opens with punctuation.
// Connects to data-controller="monster-attack-preview"
export default class extends Controller {
	static targets = ["weapon", "damage", "damageBonus", "effect", "preview"];

	connect() {
		this.update();
	}

	update() {
		this.previewTarget.textContent = this.damageDescription();
	}

	damageDescription() {
		const dice = this.diceLabel();
		const effect = this.effectTarget.value.trim();
		if (!dice) return effect;
		if (!effect) return dice;
		return `${dice}${effect.startsWith(",") || effect.startsWith(";") ? "" : " "}${effect}`;
	}

	diceLabel() {
		const damage = this.damageTarget.value.trim();
		if (damage) return `${damage}${this.signedBonus()}`;

		if (this.weaponTarget.value === "1") {
			const bonus = this.signedBonus();
			return bonus ? `Arma ${bonus}` : "Arma";
		}
		return "";
	}

	signedBonus() {
		const value = Number.parseInt(this.damageBonusTarget.value, 10);
		if (!Number.isFinite(value) || value === 0) return "";
		return value > 0 ? `+${value}` : `${value}`;
	}
}
